<div class="dialog-header">
  <h2>{{ data.label || data.title }}</h2>

  <div>
    <mds-button type="secondary" [aria-label]="exportButtonLabel" [disabled]="!form?.valid"
      icon="download" [isIconLeft]="true"
      (click)="onExport()">
      {{ exportButtonLabel }}
    </mds-button>
    <mds-button type="primary" aria-label="Update" [disabled]="!form?.valid || !payload"
      (click)="onSave()">
      Update
    </mds-button>
  </div>
</div>
<app-epd-edit-section [data]="data.sections[0]" (modelChanged)="onModelChanged($event)">

</app-epd-edit-section>
